import { useState, useEffect } from 'react'

const usePreloadImage = (src) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!src) return

        const image = new Image()
        image.src = src

        image.onload = () => {
            setLoaded(true)
        }
    }, [src])

    return loaded
}

export default usePreloadImage